import type { FC, ReactNode } from 'react';
import './PageLayout.css';
import classNames from 'classnames';

export type PageLayoutProps = {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
};

export const PageLayout: FC<PageLayoutProps> = (props) => (
  <div
    className={classNames(
      'page-layout m-4',
      !props.noPadding && 'p-4',
      props.className,
    )}
  >
    {props.children}
  </div>
);
